export const ItemTypes = {
  DRAG_SOURCE: 'drag-source',
}
